"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reject = _interopRequireDefault(require("lodash/reject"));
var _utilities = require("../../../../utilities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var mapLayers = [{
  key: 'radar',
  label: 'Radar'
}, {
  key: 'lines',
  label: 'Lines'
}, {
  key: 'facilities',
  label: 'Parking Lots'
}, {
  key: 'mileposts',
  label: 'Mileposts'
}, {
  key: 'stations',
  label: 'Stations'
}, {
  key: 'equipment',
  label: 'Equipment'
}, {
  key: 'tasks',
  label: 'Tasks'
}];
var LayerModal = /*#__PURE__*/function (_Component) {
  _inherits(LayerModal, _Component);
  var _super = _createSuper(LayerModal);
  function LayerModal() {
    _classCallCheck(this, LayerModal);
    return _super.apply(this, arguments);
  }
  _createClass(LayerModal, [{
    key: "getMapLayers",
    value: function getMapLayers() {
      return this.props.includeTasksLayer ? mapLayers : (0, _reject["default"])(mapLayers, function (layer) {
        return layer.key == 'tasks';
      });
    }
  }, {
    key: "toggleAll",
    value: function toggleAll() {
      var isActive = !this.props.layers.all;
      var nextLayers = this.getMapLayers().reduce(function (acc, curr) {
        acc[curr.key] = isActive;
        return acc;
      }, {
        all: isActive
      });
      this.props.setLayers(nextLayers);
    }

    //RENDER
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        layers = _this$props.layers,
        toggleAll = _this$props.toggleAll,
        setLayers = _this$props.setLayers,
        includeTasksLayer = _this$props.includeTasksLayer;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "container",
        id: "layer-picker"
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "overlay-title"
      }, "Map Layers"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "all"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn" + (layers.all ? " active" : ""),
        onClick: function onClick() {
          return _this.toggleAll();
        }
      }, "All")), /*#__PURE__*/_react["default"].createElement("section", {
        className: "overlay-container btn-layout"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn ".concat(layers.trains ? "active" : ""),
        onClick: function onClick() {
          return setLayers({
            trains: (0, _utilities.getNextTrainLayerState)(layers.trains)
          });
        }
      }, "Trains ", layers.trains ? "(".concat((0, _utilities.getTrainStateLabel)(layers.trains), ")") : null), this.getMapLayers().map(function (_ref) {
        var key = _ref.key,
          label = _ref.label;
        var classNames = "btn";
        if (layers[key]) {
          classNames += " active";
        }
        return /*#__PURE__*/_react["default"].createElement("a", {
          key: key,
          className: classNames,
          onClick: function onClick() {
            return setLayers(_defineProperty({}, key, !layers[key]));
          }
        }, label);
      })));
    }
  }]);
  return LayerModal;
}(_react.Component);
exports["default"] = LayerModal;
;